import { Merchant } from "./";

export const GET_MERCHANTS = "merchant/merchants/GET_MERCHANTS";
export const ADD_MERCHANTS = "merchant/merchants/ADD_MERCHANTS";
export const GET_MERCHANTS_FAILURE = "merchant/GET_MERCHANTS_FAILURE";

export const GET_MERCHANT = "user/api/GET_MERCHANT";
export const GET_MERCHANT_SUCCESS = "user/api/GET_MERCHANT_SUCCESS";
export const GET_MERCHANT_FAILURE = "user/api/GET_MERCHANT_FAILURE";

export const getMerchants = (q?: string) => ({
  type: GET_MERCHANTS,
  payload: q
});

export const addMerchants = (merchants: Merchant[]) => ({
  type: ADD_MERCHANTS,
  payload: merchants
});

export const getMerchantsFailure = () => ({
  type: GET_MERCHANTS_FAILURE
});

export const getMerchant = (merchant_id: number) => ({
  type: GET_MERCHANT,
  payload: merchant_id
});



// WEBPACK FOOTER //
// ./client/modules/Merchant/actions.ts